const githubURL = "https://github.com/cwongura?tab=repositories";
const mediumURL = "https://medium.com/@BachelorBear";
const twitterURL = "https://twitter.com/bear_bachelor";
const linkedInURL = "https://www.linkedin.com/in/chatarin-wong-u-railertkun-4ab076108/";

export {
  githubURL,
  mediumURL,
  twitterURL,
  linkedInURL
}